<div class="loader">
  <span>Loading </span>
  <span class="dots">
    <span class="dot">.</span>
    <span class="dot">.</span>
    <span class="dot">.</span>
  </span>
</div>